import { SubMenuItem } from "src/constants/modules";
import flightsImage from "src/assets/images/LandingPage/flight.png";
import hotelsImage from "src/assets/images/LandingPage/Hotels.png";
import pointsExchangeImage from "src/assets/images/LandingPage/pointsexchange.png";
import giftcardsImage from "src/assets/images/LandingPage/giftcard.png";
import discountsImage from "src/assets/images/LandingPage/discounts.png";

export type SectionTitle = "travel" | "mobilePayments" | "offers";

export type ModuleEntry = { type: SubMenuItem["type"]; image: string };

export const SECTIONS: Record<SectionTitle, ModuleEntry[]> = {
  travel: [
    { type: "Travel", image: flightsImage },
    { type: "Hotel", image: hotelsImage },
  ],
  mobilePayments: [
    { type: "Loyalty", image: pointsExchangeImage },
    { type: "TopUp", image: hotelsImage },
  ],
  offers: [
    { type: "Discounts", image: discountsImage },
    { type: "GiftCards", image: giftcardsImage },
  ],
};

export const MODULE_STYLE = Object.values(SECTIONS)
  .flat()
  .reduce<Partial<Record<SubMenuItem["type"], { image: string }>>>((acc, { type, image }) => {
    acc[type] = { image };
    return acc;
  }, {});
